import { render } from "./EnNotificationsMenu.vue?vue&type=template&id=428d8a0e&scoped=true&ts=true"
import script from "./EnNotificationsMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnNotificationsMenu.vue?vue&type=script&setup=true&lang=ts"

import "./EnNotificationsMenu.vue?vue&type=style&index=0&id=428d8a0e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428d8a0e"],['__file',"Shared/components/notifications/EnNotificationsMenu/EnNotificationsMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "428d8a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('428d8a0e', __exports__)) {
    api.reload('428d8a0e', __exports__)
  }
  
  module.hot.accept("./EnNotificationsMenu.vue?vue&type=template&id=428d8a0e&scoped=true&ts=true", () => {
    api.rerender('428d8a0e', render)
  })

}


export default __exports__